export default __webpack_public_path__ + "static/media/avatar_koala2.c9365e9b.mp3";